import { AppState } from "../../../redux-configuration/AppState";

export const postInstantOnInstagramLoadingSelector = (appState: AppState): boolean=> appState.managementInstant.postInstantOnInstagram.loading
export const postInstantOnInstagramErrorSelector = (appState: AppState): string | undefined => appState.managementInstant.postInstantOnInstagram.error
